module.exports = __webpack_public_path__ + "img/church_small.2539dde4.png";